<div mat-dialog-title class="title">
    <span class="heading">Client to Client Journal Request</span>
    <button (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>

<div class="wrapper">
    <div class="form-container">
        <form [formGroup]="journalRequestForm">
            <mat-form-field class="fullLength" *ngIf="showReturnReason">
                <mat-label style="color: red;">Rejected Reason</mat-label>
                <input matInput formControlName="returnReason" readonly>
            </mat-form-field>

            <div class="search">
                <mat-form-field class="halfLength">
                    <mat-label>Matter From</mat-label>
                    <button *ngIf="journalRequestForm.get('matterFrom')?.value"
                            (click)="clearSearchFilter('from')" mat-icon-button matSuffix [disabled]="isDisabled">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input matInput formControlName="matterFrom" [matAutocomplete]="autoFrom" />
                    <mat-error *ngIf="journalRequestForm.get('matterFrom')?.hasError('required')">
                        Please select a matter.
                    </mat-error>
                </mat-form-field>

                <mat-autocomplete #autoFrom="matAutocomplete">
                    <mat-option *ngIf="isLoading">Loading....</mat-option>
                    <mat-option *ngIf="noData && !isLoading">No matching matters found.</mat-option>
                    <div *ngIf="!isLoading && !noData">
                        <mat-option *ngFor="let item of matterFromDropdownData"
                                    [value]="item.description"
                                    (onSelectionChange)="lookupSelecttionChangd($event, 'matterFrom')">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                    </div>
                </mat-autocomplete>

                @if (showLinkToOpenMatter1()) {
                <div class="actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl1"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterFromNo }})
                        </a>
                        <button mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl1"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <div class="search">
                <mat-form-field class="halfLength">
                    <mat-label>Matter To</mat-label>
                    <button *ngIf="journalRequestForm.get('matterTo')?.value"
                            (click)="clearSearchFilter('to')" mat-icon-button matSuffix [disabled]="isDisabled">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input matInput formControlName="matterTo" [matAutocomplete]="autoTo" (beforeinput)="$event.preventDefault()" class="readonly-select-input" />

                    <mat-error *ngIf="journalRequestForm.get('matterTo')?.hasError('required')">
                        Please select a matter.
                    </mat-error>
                    <mat-error *ngIf="journalRequestForm.get('matterTo')?.hasError('sameMatter')">
                        Source and destination matters must be different.
                    </mat-error>
                </mat-form-field>

                <mat-autocomplete #autoTo="matAutocomplete">
                    <mat-option *ngIf="isMatterToLoading" disabled>Loading....</mat-option>
                    <mat-option *ngIf="!isMatterToLoading && !matterToDropdownData.length" disabled>No matters available for the selected Matter From client.</mat-option>
                    <div *ngIf="!isMatterToLoading && matterToDropdownData.length">
                        <mat-option *ngFor="let item of matterToDropdownData"
                                    [value]="item.description"
                                    (onSelectionChange)="lookupSelecttionChangd($event, 'matterTo')">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                    </div>
                </mat-autocomplete>

                @if (showLinkToOpenMatter2()) {
                <div class="actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl2"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterToNo }})
                        </a>
                        <button mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl2"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <div class="search">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Client Bank</mat-label>
                    <mat-select formControlName="clientBankAccount1" required>
                        <mat-option *ngFor="let account of filteredBankAccounts"
                                    [value]="account">
                            {{ account.accountId }} -
                            {{ account.description }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="journalRequestForm.get('clientBankAccount1')?.hasError('required')">
                        Please select a bank account.
                    </mat-error>
                </mat-form-field>

                @if (showLinkToOpenMatter1()) {
                <div class="actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterOverviewUrl1"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Actionstep Matter ({{ matterFromNo }}) Overview
                        </a>
                        <button type="button" mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterOverviewUrl1"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <div class="search">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Client Bank</mat-label>
                    <mat-select formControlName="clientBankAccount2" required>
                        <mat-option *ngFor="let account of filteredBankAccounts"
                                    [value]="account">
                            {{ account.accountId }} -
                            {{ account.description }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="journalRequestForm.get('clientBankAccount2')?.hasError('required')">
                        Please select a bank account.
                    </mat-error>
                </mat-form-field>

                @if (showLinkToOpenMatter2()) {
                <div class="actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterOverviewUrl2"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Actionstep Matter ({{ matterToNo }}) Overview
                        </a>
                        <button type="button" mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterOverviewUrl2"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <mat-form-field class="halfLength">
                <mat-label>Reason for transfer</mat-label>
                <input matInput formControlName="reason" />
                <mat-error *ngIf="journalRequestForm.get('reason')?.invalid">
                    Please enter a valid reason for transfer.
                </mat-error>
            </mat-form-field>

            <mat-form-field class="halfLength">
                <mat-label>Amount</mat-label>

                <input matInput
                       type="text"
                       maxlength="12"
                       formControlName="amount"
                       (keydown)="validateInput($event)"
                       appCurrencyInput />

                <mat-error *ngIf="journalRequestForm.get('amount')?.invalid">
                    Please enter a valid amount.
                </mat-error>
            </mat-form-field>


            <div class="date-time-row">
                <mat-form-field color="accent" class="date-field">
                    <mat-label>Requested Date</mat-label>
                    <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                    <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                    <mat-datepicker #requestedDatePicker />
                    @if (journalRequestForm.get('dateRequested')?.touched && journalRequestForm.get('dateRequested')?.invalid) {
                    <mat-error>Please select a date.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field color="accent" class="time-field">
                    <mat-label>Requested Time</mat-label>
                    <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                    @if (journalRequestForm.get('requestedTime')?.touched && journalRequestForm.get('requestedTime')?.invalid) {
                    <mat-error>Please enter a time.</mat-error>
                    }
                </mat-form-field>
            </div>

            @if(showDateTransaction()){
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput [matDatepicker]="transactionDatePicker" formControlName="dateTransaction" />
                        <mat-datepicker-toggle matSuffix [for]="transactionDatePicker" />
                        <mat-datepicker #transactionDatePicker />
                        @if (journalRequestForm.get('dateTransaction')?.touched && journalRequestForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
            }

            <mat-form-field appearance="fill" class="upload-doc fullLength">
                <mat-label>Files to upload</mat-label>
                <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly [disabled]="isDisabled">
                <button (click)="fileInput.click()" mat-icon-button matSuffix [disabled]="isDisabled">
                    <mat-icon>upload_file</mat-icon>
                </button>
                <button *ngIf="displayFile.length > 0" (click)="clearUpload()" mat-icon-button matSuffix>
                    <mat-icon>clear</mat-icon>
                </button>
                <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
            </mat-form-field>
            <div class="action-button">
                <button mat-raised-button color="accent" type="submit" (click)="delete()" [disabled]="isRejectDisabled">
                    Reject
                </button>
                <button mat-raised-button color="accent" type="submit" (click)="withdrawJournal()" [disabled]="isWithdrawDisabled">
                    Withdraw Journal
                </button>
                <button mat-raised-button color="accent" type="submit" (click)="approveRequest()" [disabled]="isDisabled">
                    Submit
                </button>
            </div>
        </form>
    </div>
</div>
